"use client"

import * as React from "react"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { UTMLink } from '@/components/custom-ui/utm-link'

// Use UTMLink for public pages
const Link = UTMLink

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip"
import { Linkedin, Send, X } from "lucide-react"
import { useAuth } from "@/lib/auth.tsx"

function Footerdemo() {
  const [isDarkMode, setIsDarkMode] = React.useState(false)
  const { user } = useAuth()

  React.useEffect(() => {
    // Get the initial theme from localStorage or system preference
    const isDark = document.documentElement.classList.contains('dark')
    setIsDarkMode(isDark)
  }, [])

  React.useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add("dark")
    } else {
      document.documentElement.classList.remove("dark")
    }
  }, [isDarkMode])

  // Return null for authenticated users, show footer only for unauthenticated
  if (user) {
    return null
  }

  return (
    <footer className="relative border-t bg-background text-foreground transition-colors duration-300">
      <div className="container mx-auto max-w-5xl px-4 py-8 md:px-6 lg:px-8">
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          <div>
            <h3 className="mb-3 text-lg font-semibold">Quick Links</h3>
            <nav className="space-y-1.5 text-sm">
              <Link to="/" className="block transition-colors hover:text-primary">
                Home
              </Link>
              <Link to="/about" className="block transition-colors hover:text-primary">
                About Us
              </Link>
              <Link to="/services" className="block transition-colors hover:text-primary">
                Services
              </Link>
              <Link to="/products" className="block transition-colors hover:text-primary">
                Products
              </Link>
              <Link to="/careers" className="block transition-colors hover:text-primary">
                Careers
              </Link>
              <Link to="/contact" className="block transition-colors hover:text-primary">
                Contact
              </Link>
            </nav>
          </div>
          <div>
            <h3 className="mb-3 text-lg font-semibold">Contact Us</h3>
            <address className="space-y-1.5 text-sm not-italic">
              <p>P.O. Box 435</p>
              <p>Lisle, IL 60532</p>
              <p>Email: info@rainfactory.ai</p>
            </address>
          </div>
          <div>
            <h3 className="mb-3 text-lg font-semibold">Follow Us</h3>
            <div className="mb-4 flex space-x-2">
              {/* <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <Button variant="outline" size="icon" className="h-8 w-8 rounded-full">
                      <Facebook className="h-4 w-4" />
                      <span className="sr-only">Facebook</span>
                    </Button>
                  </TooltipTrigger>
                  <TooltipContent>
                    <p>Follow us on Facebook</p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider> */}
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <a href="https://x.com/RainfactoryAI" target="_blank" rel="noopener noreferrer">
                      <Button variant="outline" size="icon" className="h-8 w-8 rounded-full">
                        <X className="h-4 w-4" />
                        <span className="sr-only">X (formerly Twitter)</span>
                      </Button>
                    </a>
                  </TooltipTrigger>
                  <TooltipContent>
                    <p>Follow us on X</p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
              {/* <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <Button variant="outline" size="icon" className="h-8 w-8 rounded-full">
                      <Instagram className="h-4 w-4" />
                      <span className="sr-only">Instagram</span>
                    </Button>
                  </TooltipTrigger>
                  <TooltipContent>
                    <p>Follow us on Instagram</p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider> */}
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <a href="https://www.linkedin.com/company/rainfactory-ai/about/" target="_blank" rel="noopener noreferrer">
                      <Button variant="outline" size="icon" className="h-8 w-8 rounded-full">
                        <Linkedin className="h-4 w-4" />
                        <span className="sr-only">LinkedIn</span>
                      </Button>
                    </a>
                  </TooltipTrigger>
                  <TooltipContent>
                    <p>Connect with us on LinkedIn</p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            </div>
            <div>
              <h3 className="mb-2 text-sm font-semibold">Stay Connected</h3>
              <form className="relative max-w-xs">
                <Input
                  type="email"
                  placeholder="Enter your email"
                  className="pr-12 h-9 text-sm"
                />
                <Button
                  type="submit"
                  size="icon"
                  className="absolute right-1 top-1 h-7 w-7 rounded-full bg-primary text-primary-foreground"
                >
                  <Send className="h-3.5 w-3.5" />
                  <span className="sr-only">Subscribe</span>
                </Button>
              </form>
            </div>
          </div>
        </div>
        <div className="mt-6 flex flex-col items-center justify-between gap-3 border-t pt-4 text-center md:flex-row">
          <p className="text-xs text-muted-foreground">
            © 2025 Rainfactory, Ltd. All rights reserved.
          </p>
          <nav className="flex gap-4 text-xs">
            <Link to="/privacy-policy" className="transition-colors hover:text-primary">
              Privacy Policy
            </Link>
            <Link to="/terms-of-service" className="transition-colors hover:text-primary">
              Terms of Service
            </Link>
            <Link to="/cookie-settings" className="transition-colors hover:text-primary">
              Cookie Settings
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  )
}

export { Footerdemo } 